import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {Col, Container, Row} from 'react-bootstrap';

import {DocumentUtils} from "../../../Utils/DocumentUtils";
import {ForgotPasswordPopup} from "../../../../../monitoring/src/Components/Auth/ForgotPasswordPopup";

import {LoginComponent} from "../../Auth/LoginComponent";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";

import {useLoginRedirect} from "../../../Hooks/LoginHooks";

import {service as AuthService} from "../../../Services/Core/AuthService";
import {config} from "../../../Config";

export const LoginPage = (props) => {
    const loginState = useSelector(state => state.loginState);
    const {isVerifying, errors} = loginState;
    const [state, setState] = useState({displayForgotPassword: false});
    
    let message = DocumentUtils.GetQueryStringParameter("message");
    let targetUrl = DocumentUtils.GetQueryStringParameter("redirectUrl");
    
    useLoginRedirect(targetUrl ?? '/');

    return (
        <Container className={"sb-root-page sb-login-page"}>
            <div className="login-page">
                <StreamBankPageHeader
                    Title={"Login"}
                />
                <ForgotPasswordPopup
                    authService={AuthService}
                    centered={false}
                    className={"sb-login-popup-container"}
                    onHide={() => setState({displayForgotPassword: false})}
                    show={state.displayForgotPassword}
                    showDisabledWarning={config.getEnvironment() !== 'prod'}
                    showEmailField={true}
                    suggestedEmail={loginState.fields.email}
                />
                <Row key={1}>
                    <Col xs={12} md={12}>
                        <h2>{loginState.title || 'Login'}</h2>
                        <hr />
                    </Col>
                </Row>
                {
                    (!isVerifying && errors.login) &&
                    <Row key={3}>
                        <Col xs={12}>
                            <p className="sb-login-popup-container-error-message">{errors.login}</p>
                        </Col>
                    </Row>
                }
                {
                    (!isVerifying && !errors.login) && message &&
                    <Row key={4}>
                        <Col xs={12}>
                            <p className="sb-login-popup-container-error-message">{message}</p>
                        </Col>
                    </Row>
                }
                <Row key={2}>
                    <Col xs={12} md={3} />
                    <Col xs={12} md={6}>
                        <LoginComponent
                            ForgotPassword={() => setState({displayForgotPassword: true})}
                        />
                    </Col>
                    <Col xs={12} md={3} />
                </Row>
            </div>
        </Container>
    );
};


